import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function About({ t }) {
  return (
    <section id="about" className="about-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} className="text-center mb-5">
            <h2 className="mb-4">
              <span className="text-gradient">{t.about}</span>
            </h2>
            <p className="lead content-wrapper">
              {t.aboutContent}
            </p>
          </Col>
        </Row>
        
        <Row className="g-4 mt-4">
          <Col md={6} lg={5} className="mx-auto">
            <Card className="vision-mission-card h-100 border-0 shadow-sm">
              <Card.Body className="text-center p-4">
                <div className="mb-3">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-gradient text-white" style={{ width: '60px', height: '60px' }}>
                    <i className="fas fa-eye fa-lg"></i>
                  </div>
                </div>
                <h3 className="mb-3">{t.vision}</h3>
                <p className="content-wrapper mb-0">
                  {t.visionContent}
                </p>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={6} lg={5} className="mx-auto">
            <Card className="vision-mission-card h-100 border-0 shadow-sm">
              <Card.Body className="text-center p-4">
                <div className="mb-3">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-gradient text-white" style={{ width: '60px', height: '60px' }}>
                    <i className="fas fa-bullseye fa-lg"></i>
                  </div>
                </div>
                <h3 className="mb-3">{t.mission}</h3>
                <p className="content-wrapper mb-0">
                  {t.missionContent}
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
